import React, { Component } from "react";
import heic2any from "heic2any";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FileViewer from "react-file-viewer";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import FetchServerData from "../../../provider/FetchServerData";
import Utils from "../../../provider/Utils";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import store from "../../../redux/store";
import AddressWithTimezone from "../address/AddressWithTimezone";
import CancelIconButton from "../buttons/CancelIconButton";
import SaveButton from "../buttons/SaveButton";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import PtsAlert from "../ptsAlert/PtsAlert";
import "./Organization.css";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
class Organization extends Component {
  addressRef = React.createRef();
  header = store.getState().header.header;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  organizationTypeList = store.getState().staticData.organizationTypeList;
  businessTypeList = store.getState().staticData.businessTypeList;
  businessIndustryList = store.getState().staticData.businessIndustryList;
  paymentServiceTypeList = store.getState().staticData.paymentServiceTypeList;
  logoData = store.getState().appUserData.logoData.logo;
  profile = store.getState().appUserData.appUserData.appuser?.profile;
  defaultCountry = store.getState().staticData.defaultCountry;

  constructor(props) {
    super(props);
    let action = props.action;
    let pageId = props.pageId;
    this.state = {
      action: action,
      pageId: pageId,
      name: "",
      eIn: "",
      email: "",
      phone: "",
      smsTAndCUrl: "",
      smsPrivacyPolicyUrl: "",
      privacyErrorMessageText: "",
      timeZone: null,
      orgBusinessType: null,
      businessIndustry: null,
      paymentType: null,
      businessType: null,
      paypalId: "",
      organizationTypeList: this.organizationTypeList,
      businessTypeList: this.businessTypeList,
      businessIndustryList: this.businessIndustryList,
      paymentServiceTypeList: this.paymentServiceTypeList,
      address: {},
      render: false,
      companyLogo: this.logoData ? this.logoData : "",
      showFile: false,
      taxExemptNo: false,
      taxExYes: false,
      showFileView: false,
      selectedFile: { name: "" },
      selectedTaxDocFile: { name: "" },
      taxExemptDocId: "",
      companyWebsite: "",
      registrationDate: "",
      customerUid: "",
      primaryUser: null,
      firstNameAlternateValue: "Friend",
      textingWindowStart: "",
      textingWindowEnd: "",
      startHour: "",
      startMinute: "",
      startAmpm: "",
      endHour: "",
      endMinute: "",
      endAmpm: "",
      getUpdatePermission: false,
      taxErrorMessage: false,
      isDeletelogo: false,
      isDragging: false,
      isTaxDocDragging: false,
    };
    this.getOrganizationDetails();
  }

  componentWillReceiveProps() {
    let organizationTypeList = store.getState().staticData.organizationTypeList;
    let businessTypeList = store.getState().staticData.businessTypeList;
    let businessIndustryList = store.getState().staticData.businessIndustryList;
    let paymentServiceTypeList =
      store.getState().staticData.paymentServiceTypeList;
    this.setState({
      organizationTypeList: organizationTypeList,
      businessTypeList: businessTypeList,
      businessIndustryList: businessIndustryList,
      paymentServiceTypeList: paymentServiceTypeList,
      paymentType:
        paymentServiceTypeList !== undefined
          ? Utils.getArrayElement(paymentServiceTypeList, 0)
          : [],
    });
  }

  getOrganizationDetails() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService("/organizationms/getOrg", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let organizationData = output.data.organization;
          let primaryUser = output.data.primaryUser;
          let orgLogoDocument = output.data.organization?.orgLogoDocument;
          let smsCredits = output.data.smsCredits;
          if (smsCredits !== null) {
            const { showCardexpiryMessage, ...smsCreditsWithoutFlag } = smsCredits;

            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCreditsWithoutFlag)
              );
            } else {
              store.dispatch(
                AppUserDataAction.setUsage(smsCreditsWithoutFlag)
              );
            }
          }
          let logoData = {
            logo: orgLogoDocument?.url !== null ? orgLogoDocument?.url : "",
            logoFilename:
              orgLogoDocument?.filename !== null
                ? orgLogoDocument?.filename
                : "",
            logoFileextension:
              orgLogoDocument?.fileext !== null ? orgLogoDocument?.fileext : "",
          };
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          store.dispatch(AppUserDataAction.setLogo(logoData));
          if (
            organizationData?.taxExcemptDocument !== null &&
            organizationData?.taxExcemptDocument?.url !== null
          ) {
            const { url, fileext, id } = organizationData?.taxExcemptDocument;
            const fileType = fileext?.split(".").pop();

            this.setState({
              newUrl: url,
              fileType: fileType,
              taxExemptDocId: id,
              open: true,
              taxExYes: true,
              uploadFileShow: true,
              showFileView: true,
            });
          }
          let taxExemptNoFlag = false;
          if (organizationData?.isTaxExemptDocument === false) {
            taxExemptNoFlag = true;
          }

          const start = this.convertTo12Hour(organizationData?.textingWindowStart);
          const end = this.convertTo12Hour(organizationData?.textingWindowEnd);

          this.setState({
            render: true,
            action: "view",
            companyLogo: logoData,
            taxExYes: organizationData?.isTaxExemptDocument,
            uploadFileShow: organizationData?.isTaxExemptDocument,
            // showFileView: organizationData.isTaxExemptDocument,
            taxExemptNo: taxExemptNoFlag,
            id: organizationData.id,
            name: organizationData.name,
            eIn: Utils.maskEIN(organizationData.ein),
            eInNumber: organizationData.ein,
            email: organizationData.email,
            smsTAndCUrl: organizationData.tandc,
            smsPrivacyPolicyUrl: organizationData.privacyPolicy,
            phone: organizationData.phone,
            companyType: organizationData.companyType,
            orgBusinessType: organizationData.orgBusinessType,
            businessIndustry: organizationData.businessIndustry,
            address: organizationData.address,
            timeZone: organizationData.timezone,
            paymentType: organizationData?.paymentServicestype,
            paymentPaypalId: organizationData?.paymentPaypal?.id,
            paypalId: organizationData?.paymentPaypal?.paypalid,
            companyWebsite: organizationData.website,
            businessType: organizationData.businessType,
            registrationDate: organizationData.createdOn,
            customerUid: organizationData.customerUid,
            firstNameAlternateValue: organizationData?.firstNameAlternateValue !== null ? organizationData?.firstNameAlternateValue : "Friend",
            textingWindowStart: organizationData?.textingWindowStart,
            textingWindowEnd: organizationData?.textingWindowEnd,
            startHour: start?.hour,
            startMinute: start?.minute,
            startAmpm: start?.ampm,
            endHour: end?.hour,
            endMinute: end?.minute,
            endAmpm: end?.ampm,
            primaryUser: primaryUser,
            getUpdatePermission: getUpdatePermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }


  convertTo12Hour = (time) => {
    if (!time) return { hour: "", minute: "", ampm: "" };

    let [hour, minute] = time?.split(":");
    hour = parseInt(hour, 10);

    const ampm = hour >= 12 ? "pm" : "am";

    hour = hour % 12;
    hour = hour === 0 ? 12 : hour;

    return {
      hour: hour?.toString()?.padStart(2, "0"),
      minute,
      ampm,
    };
  };

  editOrganizationDetails() {
    this.setState({
      action: "edit",
      paymentType:
        this.state.paymentType !== null
          ? this.state.paymentType
          : Utils.getArrayElement(this.paymentServiceTypeList, 0),
      timeZone: this.state.timeZone,
      taxErrorMessage: false,
    });
  }

  editCancel() {
    this.setState({
      action: "view",
    });
  }

  handleAddressChange(address) {
    this.setState({ address: address });
  }

  handleEinChange(e) {
    let val = e.target.value;
    let value = this.einNumberAutoFormat(val);
    let res = value.substring(0, 11);
    if (res.length < 11) {
      this.setState({
        eIn: value,
        einErrorMessageText: "",
        eInNumber: e.target.value,
      });
    } else {
      Utils.maxFieldLength(9);
    }
  }

  einNumberAutoFormat(einNumber) {
    const number = einNumber.replace(/\D/g, "");
    const isCanada = Utils.equalsIgnoreCase(
      this.state.country?.name,
      "Canada"
    );

    if (isCanada) {
      const trimmed = number.substring(0, 9);
      if (trimmed.length > 5) {
        return trimmed.replace(/(\d{5})(\d{0,4})/, "$1 $2").trim();
      }

      return trimmed;
    } else {
      const trimmed = number.substring(0, 9);
      if (trimmed.length > 2) {
        return trimmed.replace(/(\d{2})(\d{0,7})/, "$1-$2");
      }

      return trimmed;
    }
  }


  handleCompanyTypeChange(selectedType) {
    this.state.companyType = selectedType;
    this.setState({
      companyType: selectedType,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  handleBusinessNameChange(e) {
    this.setState({ name: e.target.value });
  }

  handleOrgBusinessTypeChange(selectedType) {
    this.state.orgBusinessType = selectedType;
    this.setState({
      orgBusinessType: selectedType,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }
  handlePaymentTypeChange(selectedType) {
    this.setState({
      paymentType: selectedType,
      paypalId: "",
    });
  }

  handlePaymentPayPalChange(e) {
    this.setState({ paypalId: e.target.value });
  }

  handleBusinessIndustryChange(selectedIndustry) {
    this.state.businessIndustry = selectedIndustry;
    this.setState({
      businessIndustry: selectedIndustry,
    });
    if (undefined !== this.state.onChange && null !== this.state.onChange) {
      this.state.onChange(this.state);
    }
  }

  handleSmsTAndCUrlChange(e) {
    let pattern = Utils.urlPattern(e.target.value);
    if (pattern === true) {
      this.setState({ smsTAndCUrl: e.target.value, errorMessageText: "" });
    } else {
      this.setState({
        smsTAndCUrl: e.target.value,
        errorMessageText: "Please enter valid URL",
      });
    }
  }
  handleSmsPrivacyPolicyUrlChange(e) {
    let pattern = Utils.urlPattern(e.target.value);
    if (pattern === true) {
      this.setState({
        smsPrivacyPolicyUrl: e.target.value,
        privacyErrorMessageText: "",
      });
    } else {
      this.setState({
        smsPrivacyPolicyUrl: e.target.value,
        privacyErrorMessageText: "Please enter valid URL",
      });
    }
  }

  convertTo24Hour = (hour, minute, ampm) => {
    let h = parseInt(hour, 10);

    if (ampm === "pm" && h !== 12) h += 12;
    if (ampm === "am" && h === 12) h = 0;

    return `${h.toString()?.padStart(2, "0")}:${minute}:00`;
  };

  updateOrganizationToBackend() {
    const startTime = this.convertTo24Hour(
      this.state.startHour,
      this.state.startMinute,
      this.state.startAmpm
    );

    const endTime = this.convertTo24Hour(
      this.state.endHour,
      this.state.endMinute,
      this.state.endAmpm
    );

    const postObject = {
      header: this.header,
      organization: {
        id: this.state.id,
        name: this.state.name,
        ein: this.state.eInNumber,
        tandc: this.state.smsTAndCUrl,
        privacyPolicy: this.state.smsPrivacyPolicyUrl,
        companyType: this.state.companyType,
        orgBusinessType: this.state.orgBusinessType,
        businessIndustry: this.state.businessIndustry,
        // isTaxExemptDocument: this.state.taxExYes,
        website: this.state.companyWebsite,
        // paymentPaypal: {
        //   id: this.state.paymentPaypalId,
        //   paypalid: this.state.paypalId,
        // },
        // paymentServicestype: this.state.paymentType,
        timezone:
          this.addressRef.current.state.timeZone !== null
            ? this.addressRef.current.state?.timeZone
            : this.state.timeZone,
        address: {
          id: this.addressRef.current.state.id,
          line: this.addressRef.current.state.line,
          state: {
            name: this.addressRef.current.state.state.name,
            code: this.addressRef.current.state.state.code,
            id: this.addressRef.current.state.state.id,
            country: this.addressRef.current.state.country,
          },
          city: this.addressRef.current.state.city,
          zipcode: this.addressRef.current.state.zipCode,
        },
        firstNameAlternateValue: this.state.firstNameAlternateValue,
        textingWindowStart: startTime,
        textingWindowEnd: endTime,
      },
    };
    FetchServerData.callPostService("/organizationms/update", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let organizationData = output.data.organization;
          let taxExemptNoFlag = false;
          if (organizationData?.isTaxExemptDocument === false) {
            taxExemptNoFlag = true;
          }
          store.dispatch(AppUserDataAction.setOrganization(organizationData));
          const start = this.convertTo12Hour(organizationData?.textingWindowStart);
          const end = this.convertTo12Hour(organizationData?.textingWindowEnd);
          this.setState({
            render: true,
            action: "view",
            name: organizationData.name,
            eIn: Utils.maskEIN(organizationData.ein),
            eInNumber: organizationData.ein,
            email: organizationData.email,
            smsTAndCUrl: organizationData.tandc,
            smsPrivacyPolicyUrl: organizationData.privacyPolicy,
            phone: organizationData.phone,
            companyType: organizationData.companyType,
            orgBusinessType: organizationData.orgBusinessType,
            businessIndustry: organizationData.businessIndustry,
            address: organizationData.address,
            timeZone: organizationData.timezone,
            paymentPaypalId: organizationData?.paymentPaypal?.id,
            paypalId: organizationData?.paymentPaypal?.paypalid,
            // taxExYes: organizationData.isTaxExemptDocument,
            // uploadFileShow: organizationData.isTaxExemptDocument,
            taxExemptNo: taxExemptNoFlag,
            // showFileView: organizationData.isTaxExemptDocument,
            firstNameAlternateValue: organizationData?.firstNameAlternateValue !== null ? organizationData?.firstNameAlternateValue : "Friend",
            textingWindowStart: organizationData?.textingWindowStart,
            textingWindowEnd: organizationData?.textingWindowEnd,
            startHour: start?.hour,
            startMinute: start?.minute,
            startAmpm: start?.ampm,
            endHour: end?.hour,
            endMinute: end?.minute,
            endAmpm: end?.ampm,
          });
        } else {
        }
      }
    );
  }
  onFileChange = (event) => {
    // Update the state
    let currentFile = null;
    if (event.target.files[0]) {
      currentFile = URL.createObjectURL(event.target.files[0]);
    }

    const file = event.target.files[0];

    if (file) {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target.result;

        img.onload = () => {
          // Check the image dimensions
          if (img.width <= 300 && img.height <= 100) {
            this.setState({
              imagePreview: e.target.result,
              imageError: "",
              selectedFile: event.target.files[0],
              currentFile: currentFile,
            });
          } else {
            this.setState({
              imagePreview: null,
              imageError: "The selected file is not the required type or size.",
            });
          }
        };
      };

      reader.readAsDataURL(file);
    }

    // this.setState({
    //   selectedFile: event.target.files[0],
    //   currentFile: currentFile,
    // });
  };

  onLogoUpload = (e) => {
    if (!this.state.selectedFile.name || this.state.selectedFile.name === "") {
      PtsAlert.error("Please select file to upload");
      return;
    }
    let header = store.getState().header.header;
    const formData = new FormData();
    formData.append(
      "file",
      this.state.selectedFile,
      this.state.selectedFile.name
    );
    formData.append("tid", header.tid);
    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("isAp", header.isAp);
    formData.append("appclient", header.appclient);
    // Details of the uploaded file

    FetchServerData.callPostService(
      "/organizationms/uploadLogo",
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        this.fileUploadRef.current.value = "";
        let orgLogoDocument = output.data?.orgLogoDocument;
        let logoData = {
          logo: orgLogoDocument?.url,
          logoFilename: orgLogoDocument?.fileName,
          logoFileextension: orgLogoDocument?.fileext,
        };
        store.dispatch(AppUserDataAction.setLogo(logoData));
        this.setState({
          render: true,
          action: "view",
          currentFile: null,
          companyLogo: logoData,
        });
      }
    });
  };

  deleteOrgLogoInBackend() {
    const postObject = {
      header: this.header,
      organization: {
        id: this.state.id,
      },
    };
    FetchServerData.callPostService(
      "/organizationms/removeLogo",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let logoData = {
          logo: "",
          logoFilename: "",
          logoFileextension: "",
        };
        store.dispatch(AppUserDataAction.setLogo(logoData));
        this.setState({
          companyLogo: logoData,
          currentFile: null,
          fileType: "",
          fileName: "",
          isDeletelogo: true,
          selectedFile: { name: "" },
          imageError: false,
        });
      } else {
      }
    });
  }
  onClickShowFile() {
    this.setState({ showFile: true });
  }
  handleClose() {
    this.setState({ showFile: false });
  }

  handleTaxExemptCheckedChange(e) {
    if (e.target.checked === true) {
      this.setState({
        taxExYes: e.target.checked,
        taxExemptNo: false,
        uploadFileShow: true,
      });
    } else {
      this.setState({
        taxExYes: e.target.checked,
        taxExemptNo: false,
        uploadFileShow: false,
      });
    }
  }

  handleNoTaxExemptCheckedChange(e) {
    this.setState({
      taxExemptNo: e.target.checked,
      taxExYes: false,
      uploadFileShow: false,
    });
  }

  // optinFileHandler(e) {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   const allowedTypes = ["image/jpeg", "application/pdf"];

  //   if (!allowedTypes.includes(file.type)) {
  //     this.setState(
  //       {
  //         taxErrorMessage: true,
  //         selectedTaxDocFile: file,
  //         responseArray: [],
  //       },
  //       () => this.uploadOptInFile() // auto-upload after invalid file too?
  //     );
  //   } else {
  //     this.setState(
  //       {
  //         taxErrorMessage: false,
  //         selectedTaxDocFile: file,
  //         responseArray: [],
  //       },
  //       () => this.uploadOptInFile() // ✅ auto-upload after selecting file
  //     );
  //   }

  //   // Optional: preview file as base64
  //   const reader = new FileReader();
  //   reader.onload = (event) => {
  //     const base64 = event.target.result;
  //     const fileContent = base64.split(",")[1];
  //     this.setFile = fileContent;
  //     this.setState({ fileOptionLanguage: fileContent });
  //   };
  //   reader.readAsDataURL(file);
  // }

  handleTaxDocFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.optinFileHandler(file);
    }
  };
  handleTaxDocDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedFile: file, isTaxDocDragging: false });
      this.optinFileHandler(file);
    }
  };

  handleTaxDocDragOver = (e) => {
    e.preventDefault();
    this.setState({ isTaxDocDragging: true });
  };

  handleTaxDocDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isTaxDocDragging: false });
  };

  optinFileHandler(file) {
    // const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "application/pdf"];

    if (!allowedTypes.includes(file.type)) {
      this.setState({
        taxErrorMessage: true,
        selectedTaxDocFile: null,
        responseArray: [],
      });
      return;
    }

    this.setState(
      {
        taxErrorMessage: false,
        selectedTaxDocFile: file,
        responseArray: [],
      },
      () => this.uploadOptInFile()
    );

    const reader = new FileReader();
    reader.onload = (event) => {
      const base64 = event.target.result;
      const fileContent = base64.split(",")[1];
      this.setFile = fileContent;
      this.setState({ fileOptionLanguage: fileContent });
    };
    reader.readAsDataURL(file);
  }

  uploadOptInFile() {
    if (!this.state.selectedTaxDocFile) {
      PtsAlert.error("Please Select The File");
      return;
    }

    const formData = new FormData();
    formData.append(
      "file",
      this.state.selectedTaxDocFile,
      this.state.selectedTaxDocFile.name
    );
    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("tid", this.header.tid);
    formData.append("isAp", this.header.isAp);
    formData.append("appclient", "W");

    FetchServerData.callPostService(
      "/organizationms/uploadTaxExemptDoc",
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        const taxExcemptDocument = output.data.taxExcemptDocument;

        if (taxExcemptDocument) {
          const fileType = taxExcemptDocument?.fileext.split(".").pop();

          this.setState({
            newUrl: taxExcemptDocument?.url,
            fileType: fileType,
            open: true,
            showFileView: true,
            taxExemptDocId: taxExcemptDocument.id,
            selectedTaxDocFile: { name: "" },
          });
        }
      } else {
      }
    });
  }

  resetFile() {
    document.getElementsByName("file")[0].value = null;
  }

  handleCompanyWebsiteChange(e) {
    this.setState({ companyWebsite: e.target.value });
  }

  viewTaxDocument() {
    return (
      <Dialog
        open={this.state.showFile}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
        className="taxDocDialogue"
        onHide={this.close}
        style={{ padding: "1em" }}
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{ backgroundColor: "#37517e" }}
        >
          <span style={{ color: "#fff" }}>Tax Document</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div
            className="text-center"
            md={12}
            style={{
              width: "100%",
              height: this.state.fileType === "pdf" ? "80vh" : "100%",
              color: "#000",
              fontSize: "small",
              padding: "0.5em",
            }}
          >
            {this.state.fileType === "txt" || this.state.fileType === "pdf" ? (
              <iframe
                src={this.state.newUrl}
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            ) : this.state.fileType === "jpeg" ||
              this.state.fileType === "jpg" ? (
              <img
                src={this.state.newUrl}
                alt="Preview"
                style={{ width: "60%", height: "100%", objectFit: "contain" }}
              />
            ) : (
              <div style={{ height: "100%" }}>
                <FileViewer
                  fileType={this.state.fileType}
                  filePath={this.state.newUrl}
                  onError={this.onError}
                />
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  deleteTaxExemptDocInBackend() {
    const postObject = {
      header: this.header,
      organization: {
        id: this.state.id,
      },
      documentId: this.state.taxExemptDocId,
    };
    FetchServerData.callPostService(
      "/organizationms/deleteTaxExemptDoc",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          open: false,
          taxExemptDocId: "",
          showFileView: false,
          uploadFileShow: true,
          selectedTaxDocFile: { name: "" },
        });
      } else {
      }
    });
  }

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.onLogoChange(file);
    }
  };

  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedFile: file, isDragging: false });
      this.onLogoChange(file);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  onLogoChange = async (file) => {
    if (!file) return;

    const fileName = file?.name?.toLowerCase();
    const fileExtension = fileName.split(".").pop();
    const allowedExtensions = ["png", "jpg", "jpeg", "gif", "heic", "heif"];

    if (!allowedExtensions.includes(fileExtension)) {
      PtsAlert.error(
        "Invalid file type. Please upload JPEG, PNG, GIF, HEIC, or HEIF images only."
      );
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5 MB
    if (file.size > maxSize) {
      this.setState({
        imageError: "The file size is too large (5 MB maximum).",
      });
      return;
    }

    let workingFile = file;

    if (fileExtension === "heic") {
      const converted = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.9,
      });

      const convertedBlob =
        converted instanceof Blob ? converted : converted[0];

      workingFile = new File(
        [convertedBlob],
        file.name.replace(/\.\w+$/, ".jpg"),
        { type: "image/jpeg" }
      );
    }

    // Now validate dimensions using the (possibly converted) file
    const objectUrl = URL.createObjectURL(workingFile);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);

      if (img.width > 300 || img.height > 100) {
        this.setState({
          imageError:
            "The image dimensions are too big (300 × 100 pix maximum).",
        });
        return;
      }

      // All validations passed
      this.setState(
        {
          imagePreview: objectUrl,
          imageError: "",
          selectedFile: workingFile,
          currentFile: objectUrl,
        },
        () => this.onLogoUpload()
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      this.setState({ imageError: "Invalid image file." });
    };

    img.src = objectUrl;
  };

  handleTimeChange = (type, value) => {
    this.setState({ [type]: value });
  };

  handleFirstNameAlternateChange(e) {
    this.setState({
      firstNameAlternateValue: e.target.value
    })
  }
  render() {
    this.fileUploadRef = React.createRef();
    if (this.state.action === "view") {
      return this.viewOrganization();
    } else {
      return this.editOrganization();
    }
  }

  viewOrganization() {
    const countryName = this.state.address?.state?.country?.name;
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <div className="row" style={{ padding: "0em 0em" }}>
            <div className="col-md-6">
              <div
                className="card"
                id="giveBeeCardTopBoxShadowremove"
                style={{ borderRadius: "0px 0px 0.5rem 0.5rem" }}
              >
                <div className="card-body pb-0 ps-2">
                  <div className="row d-flex">
                    <div className="col-md-10">
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Business name
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.name}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Address
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          {Utils.getAddressAsText(
                            this.state.address !== null ? this.state.address : null
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Time Zone
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          {this.state.timeZone !== null
                            ? this.state.timeZone?.displayText
                            : ""}
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          {Utils.equalsIgnoreCase(countryName, "Canada")
                            ? "Bus. Reg. # (BN)"
                            : "Bus. Reg. # (EIN)"}
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          {(this.profile?.name === "Admin" || this.header.isAp) ?
                            <Tooltip title={this.state.eInNumber} arrow classes={{ popper: "custom-tooltip" }}>
                              <span style={{ cursor: "pointer" }}>
                                {this.state.eIn}
                              </span>
                            </Tooltip> : this.state.eIn
                          }
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Company type
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.companyType?.type}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Type
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.orgBusinessType?.type}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-email"
                          id="assetFormLabel"
                        >
                          Industry
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.businessIndustry?.industry}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-email"
                          id="assetFormLabel"
                        >
                          Website
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>
                            <a
                              className="anchortag"
                              target="_blank"
                              href={
                                this.state.companyWebsite?.includes("https://") ||
                                  this.state.companyWebsite?.includes("http://")
                                  ? this.state.companyWebsite
                                  : "http://" + this.state.companyWebsite
                              }
                            >
                              {this.state.companyWebsite}
                            </a>
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-email"
                          id="assetFormLabel"
                        >
                          T&Cs
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>
                            <a
                              className="anchortag"
                              target="_blank"
                              href={
                                this.state.smsTAndCUrl?.includes("https://") ||
                                  this.state.smsTAndCUrl?.includes("http://")
                                  ? this.state.smsTAndCUrl
                                  : "http://" + this.state.smsTAndCUrl
                              }
                            >
                              {this.state.smsTAndCUrl}
                            </a>
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-email"
                          id="assetFormLabel"
                        >
                          Privacy Policy
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>
                            <a
                              className="anchortag"
                              target="_blank"
                              href={
                                this.state.smsPrivacyPolicyUrl?.includes("https://") ||
                                  this.state.smsPrivacyPolicyUrl?.includes("http://")
                                  ? this.state.smsPrivacyPolicyUrl
                                  : "http://" + this.state.smsPrivacyPolicyUrl
                              }
                            >
                              {this.state.smsPrivacyPolicyUrl}
                            </a>
                          </span>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-email"
                          id="assetFormLabel"
                        >
                          Non-profit tax doc
                        </label>
                        {(this.profile?.name === "Admin" || this.header.isAp)
                          ?
                          <div className="col-sm-8" id="givbeeText">
                            {this.state.showFileView ? (
                              <>
                                <span
                                  onClick={(e) => this.onClickShowFile()}
                                  className="anchortag"
                                >
                                  View tax doc
                                </span>
                                <span className="fw-bold ms-2">
                                  <ClearIcon
                                    className="logoDelete"
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: "50%",
                                      border: "solid 2px",
                                      color: "#697a8d",
                                    }}
                                    onClick={this.deleteTaxExemptDocInBackend.bind(
                                      this
                                    )}
                                  />
                                </span>
                              </>
                            ) : (
                              <div
                                className="col-md-12 align-self-center csvFile"
                                id="assetFormLabel"
                                style={{
                                  display: "inline-block",
                                  cursor: "pointer",
                                }}
                              >
                                <div className="file-upload-wrapper">
                                  <label
                                    htmlFor="taxfile-upload"
                                    className={`customImageVideo-file-upload ${this.state.isTaxDocDragging ? "dragging" : ""
                                      }`}
                                    onDrop={this.handleTaxDocDrop}
                                    onDragOver={this.handleTaxDocDragOver}
                                    onDragLeave={this.handleTaxDocDragLeave}
                                  >
                                    <CloudUploadIcon className="upload-icon" />
                                    <span className="upload-text">
                                      Drop or{" "}
                                      <span className="browse-link">browse Tax files here</span>
                                    </span>

                                    <input
                                      type="file"
                                      name="file"
                                      id="taxfile-upload"
                                      required
                                      style={{ width: "240px" }}
                                      onChange={this.handleTaxDocFileChange.bind(
                                        this
                                      )}
                                    />
                                  </label>

                                  {/* <small className="uploadInfo-note">
                                    {this.state.selectedTaxDocFile?.name === ""
                                      ? "Choose file"
                                      : this.state.selectedTaxDocFile?.name}
                                  </small> */}
                                </div>
                              </div>
                            )}
                            {this.state.taxErrorMessage && (
                              <span className="errorMassageShow">
                                Only JPG and PDF files are allowed.
                              </span>
                            )}
                          </div>
                          :
                          <div className="col-sm-8" id="givbeeText">
                            <>
                              <span
                                onClick={(e) => this.onClickShowFile()}
                                className="anchortag"
                              >
                                View tax doc
                              </span>
                            </>
                          </div>
                        }
                      </div>
                      <div className="row"
                        style={{
                          margin: "1em 0em 0em 0em",
                          borderTop: "1px solid lightgray",
                        }}
                      >
                        <h6 className="ps-0 mt-3" id="headerLabel">
                          Custom Account Settings
                        </h6>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold pe-0"
                          htmlFor="basic-default-email"
                          id="assetFormLabel"
                        >
                          First Name Alternate
                          <InfoTooltip
                            data="Word inserted when first name is not found."
                            style={{
                              float: "right",
                            }}
                          />
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          {this.state.firstNameAlternateValue}
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-email"
                          id="assetFormLabel"
                        >
                          Texting Time Window
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          {`${Utils.formatTimeToAMPM(this.state.textingWindowStart)} thru ${Utils.formatTimeToAMPM(this.state.textingWindowEnd)} `}
                        </div>
                      </div>
                      <section id="logo" className="p-0">
                        <div
                          className="row"
                          md={12}
                          style={{
                            // alignItems: "flex-end",
                            // paddingBottom: "0.5em",
                            margin: "0.5em 0em 0em 0em",
                            // borderTop: "1px solid lightgray",
                            minHeight: "112px"
                          }}
                        >
                          <label
                            className="col-sm-4 col-form-label fw-bold"
                            style={{
                              // margin: "1em 0em",
                              padding: "0px",
                            }}
                          >
                            Logo <br />
                          </label>
                          {(this.profile?.name === "Admin" || this.header.isAp)
                            ?
                            <>
                              {!this.state.companyLogo?.logo && (
                                <>
                                  <div className="col-sm-8  align-self-center mt-2">
                                    <div
                                      className="col-md-12 align-self-center csvFile"
                                      id="assetFormLabel"
                                      style={{
                                        display: "inline-block",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <div className="file-upload-wrapper">
                                        <label
                                          htmlFor="file-upload"
                                          className={`customImageVideo-file-upload ${this.state.isDragging ? "dragging" : ""
                                            }`}
                                          onDrop={this.handleDrop}
                                          onDragOver={this.handleDragOver}
                                          onDragLeave={this.handleDragLeave}
                                        >
                                          <CloudUploadIcon className="upload-icon" />
                                          <span className="upload-text">
                                            Drop file here or{" "}
                                            <span className="browse-link">Browse for file</span>
                                          </span>

                                          <input
                                            id="file-upload"
                                            type="file"
                                            name="file"
                                            accept="image/*"
                                            required
                                            autoFocus={
                                              this.state.pageId === "OrgLogo"
                                                ? true
                                                : false
                                            }
                                            inputlabelprops={{
                                              shrink: true,
                                              style: {},
                                            }}
                                            style={{ margin: "0.2em" }}
                                            ref={this.fileUploadRef}
                                            onChange={this.handleFileChange.bind(this)}
                                            onClick={(e) => {
                                              e.target.value = null;
                                              this.setState({
                                                imageError: "",
                                                selectedFile: { name: "" },
                                              });
                                            }}
                                          />
                                        </label>

                                        <small className="upload-note">
                                          (max 300x100 pix - PNG, JPEG, JPG, GIF, HEIC, HEIF)
                                        </small>
                                      </div>
                                    </div>
                                    <div>
                                      <span style={{ color: "red" }}>
                                        {this.state.imageError}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )}
                              {this.state.companyLogo?.logo ? (
                                <>
                                  <div className="col-sm-8 mt-2 d-flex">
                                    <img
                                      src={Utils.getLogo()}
                                      alt=""
                                      style={{
                                        objectFit: "contain",
                                      }}
                                    />
                                    <span className="fw-bold ms-2">
                                      <ClearIcon
                                        className="logoDelete"
                                        style={{
                                          cursor: "pointer",
                                          borderRadius: "50%",
                                          border: "solid 2px",
                                        }}
                                        onClick={this.deleteOrgLogoInBackend.bind(this)}
                                      />
                                    </span>
                                  </div>
                                  <span style={{ color: "red", padding: "2px" }}>
                                    {this.state.imageError}
                                  </span>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                            :
                            <>
                              {this.state.companyLogo?.logo ? (
                                <>
                                  <div className="col-sm-8 mt-2 d-flex">
                                    <img
                                      src={Utils.getLogo()}
                                      alt=""
                                      style={{
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                </>
                              ) : (
                                ""
                              )
                              }
                            </>
                          }
                        </div>
                      </section>
                    </div>
                    <div
                      className="col-md-2 text-end"
                      style={{
                        // borderRight: "1px solid #eceaea",
                        // background: "#ececec",
                        color: "#000",
                        fontWeight: "bold",
                        textAlign: "right",
                        height: "38px",
                      }}
                    >
                      {this.state.getUpdatePermission && (
                        <Button
                          type={this.state.type ? this.state.type : ""}
                          variant="contained"
                          size="small"
                          style={{
                            background: "#d3d8de",
                            color: "#353538",
                            float: "right",
                            textTransform: "capitalize",
                          }}
                          startIcon={<EditIcon />}
                          onClick={this.editOrganizationDetails.bind(this)}
                        >
                          Edit
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div >
            </div >
            <div className="col-md-6">
              <div
                className="card"
                id="giveBeeCardTopBoxShadowremove"
                style={{ borderRadius: "0px 0px 0.5rem 0.5rem" }}
              >
                <div className="card-body pb-0 ps-2">
                  <div className="row d-flex">
                    <div className="col-md-10">
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Registration Date:
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{Utils.getUtcToLocal(this.state.registrationDate)}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          GivBee ID:
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.customerUid}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Primary User:
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.primaryUser ? this.state.primaryUser?.name : ""}</span>
                        </div>
                      </div>
                      <div className="row">
                        <label
                          className="col-sm-4 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Primary User email:
                        </label>
                        <div className="col-sm-8" id="givbeeText">
                          <span>{this.state.primaryUser?.email}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
          {this.viewTaxDocument()}
        </>
      );
    }
  }

  editOrganization() {
    const hours = Array.from({ length: 12 }, (_, i) =>
      String(i + 1).padStart(2, "0")
    );

    const minutes = Array.from({ length: 60 }, (_, i) =>
      String(i).padStart(2, "0")
    );

    const ampmOptions = ["am", "pm"];
    const countryName = this.state.address?.state?.country?.name;
    return (
      <>
        <ValidatorForm
          ref="form"
          onSubmit={this.updateOrganizationToBackend.bind(this)}
        >
          <div
            className="row mt-2"
            style={{ padding: "0em 0em", marginTop: "2px" }}
          >
            <div className="col-md-6">
              <div className="card" id="giveBeeCardTopBoxShadowremove">
                <div
                  className="card-header d-flex align-items-center justify-content-between p-2"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    Company Details
                  </h6>
                </div>
                <div className="card-body p-2">
                  <div className="row">
                    <div className="col-sm-6">
                      <label
                        className="form-label"
                        htmlFor="multiStepsFirstName"
                      >
                        {Utils.equalsIgnoreCase(countryName, "Canada")
                          ? "Bus. Reg. # (BN)"
                          : "Bus. Reg. # (EIN)"}
                      </label>
                      <input
                        title=""
                        required
                        type="text"
                        autoComplete="off"
                        placeholder={Utils.equalsIgnoreCase(this.state.defaultCountry?.name, "Canada") ? "12345 6789" : "12-123456"}
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.eIn}
                        onChange={this.handleEinChange.bind(this)}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label
                        className="form-label"
                        htmlFor="multiStepsLastName"
                      >
                        Company Type*
                      </label>
                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.organizationTypeList}
                        value={this.state.companyType}
                        getOptionLabel={(option) => option.type}
                        defaultValue={this.state.companyType}
                        onChange={(event, value) => {
                          this.handleCompanyTypeChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Please Select"
                            variant="outlined"
                            size="small"
                            className="textField"
                            required
                            title=""
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-6">
                      <label className="form-label" htmlFor="multiStepsEmail">
                        Business Name*
                        <InfoTooltip
                          data="Please enter the exact legal business
                         		name, as registered with the EIN. E.g. ABC
                      		 	Company Inc. rather than ABC Company."
                          style={{
                            float: "right",
                          }}
                        />
                      </label>
                      <input
                        title=""
                        required
                        type="text"
                        autoComplete="off"
                        value={this.state.name}
                        onChange={this.handleBusinessNameChange.bind(this)}
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        aria-label="john.doe"
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label" htmlFor="multiStepsState">
                        Business Type*
                        <InfoTooltip
                          data="What type of business are you listed on
                    								  your Tax ID listing (eg. Non-profit)"
                          style={{
                            float: "right",
                          }}
                        />
                      </label>

                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        autoComplete="off"
                        fullWidth
                        disableClearable
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.businessTypeList}
                        value={this.state.orgBusinessType}
                        getOptionLabel={(option) => option.type}
                        defaultValue={this.state.orgBusinessType}
                        onChange={(event, value) => {
                          this.handleOrgBusinessTypeChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Please Select"
                            variant="outlined"
                            size="small"
                            className="textField"
                            required
                            title=""
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-6">
                      <label className="form-label" htmlFor="multiStepsState">
                        Business Industry*
                      </label>
                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        fullWidth
                        disableClearable
                        autoComplete="off"
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.businessIndustryList}
                        value={this.state.businessIndustry}
                        getOptionLabel={(option) => option.industry}
                        defaultValue={this.state.businessIndustry}
                        onChange={(event, value) => {
                          this.handleBusinessIndustryChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Please Select"
                            variant="outlined"
                            size="small"
                            className="textField"
                            required
                            title=""
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label" htmlFor="multiStepsState">
                        Company Website*
                      </label>
                      <input
                        title=""
                        required
                        autoComplete="off"
                        type="text"
                        id="multiStepsName"
                        className="form-control"
                        name="multiStepsName"
                        value={this.state.companyWebsite}
                        onChange={this.handleCompanyWebsiteChange.bind(this)}
                      />
                    </div>
                  </div >
                  <div className="row mt-3">
                    <div className="col-sm-6">
                      <label className="form-label" htmlFor="multiStepsEmail">
                        Business T&Cs*
                        <InfoTooltip
                          data="Web address that contains your SMS Terms & Conditions"
                          style={{
                            float: "right",
                          }}
                        />
                      </label>
                      <input
                        title=""
                        required
                        type="text"
                        autoComplete="off"
                        value={this.state.smsTAndCUrl}
                        onChange={this.handleSmsTAndCUrlChange.bind(this)}
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        aria-label="john.doe"
                      />
                      {this.state.errorMessageText && (
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                          }}
                        >
                          {this.state.errorMessageText}
                        </p>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label" htmlFor="multiStepsEmail">
                        Business Privacy Policy
                        *
                      </label>
                      <input
                        title=""
                        required
                        autoComplete="off"
                        type="text"
                        value={this.state.smsPrivacyPolicyUrl}
                        onChange={this.handleSmsPrivacyPolicyUrlChange.bind(
                          this
                        )}
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        aria-label="john.doe"
                      />
                      {
                        this.state.privacyErrorMessageText && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "13px",
                            }}
                          >
                            {this.state.privacyErrorMessageText}
                          </p>
                        )
                      }
                    </div >
                  </div >
                  {/* <div className="row mt-3">
                    <div className="col-sm-7" style={{ display: "flex" }}>
                      <label className="form-label" htmlFor="multiStepsState">
                        Is your non-profit tax-exempt ?
                        *
                      </label>{" "}
                      <div
                        className="row"
                        style={{
                          display: "inline-block",
                          marginLeft: "0.1em",
                        }}
                      >
                        <span
                          className="custom-radio"
                          style={{ paddingRight: "2px", cursor: "pointer" }}
                        >
                          <input
                            type="radio"
                            required={
                              this.state.taxExemptNo === false ? "required" : ""
                            }
                            value={this.state.taxExYes}
                            onChange={(e) =>
                              this.handleTaxExemptCheckedChange(e)
                            }
                            checked={this.state.taxExYes}
                          />

                          <label className="col-form-label ps-1" htmlFor="yes">
                            Yes
                          </label>
                        </span>
                        <span
                          className="custom-radio"
                          style={{ paddingRight: "2px", cursor: "pointer" }}
                        >
                          <input
                            type="radio"
                            required={
                              this.state.taxExYes === false ? "required" : ""
                            }
                            value={this.state.taxExemptNo}
                            onChange={(e) =>
                              this.handleNoTaxExemptCheckedChange(e)
                            }
                            checked={this.state.taxExemptNo}
                          />

                          <label className="col-form-label ps-1" htmlFor="yes">
                            No
                          </label>
                        </span>
                      </div>
                    </div>
                    
                    <div className="col-sm-5" id="OrganizationCol">
                      {this.state.showFileView ? (
                        <>
                          <span
                            onClick={(e) => this.onClickShowFile()}
                            className="anchortag"
                          >
                            View tax doc
                          </span>

                          <span className="fw-bold ms-2">
                            <ClearIcon
                              className="logoDelete"
                              style={{
                                cursor: "pointer",
                                borderRadius: "50%",
                                border: "solid 2px",
                                color: "#697a8d",
                              }}
                              onClick={this.deleteTaxExemptDocInBackend.bind(
                                this
                              )}
                            />
                          </span>
                        </>
                      ) : (
                        <input
                          type="file"
                          name="file"
                          id="taxfile-upload"
                          required
                          style={{ width: "240px" }}
                          onChange={this.handleTaxDocFileChange.bind(this)}
                        />
                      )}
                    </div>
      

                    {this.state.uploadFileShow && (
                      <span
                        style={{
                          fontSize: "12px",
                          color: "blue",
                        }}
                      >
                        {
                          "(Please upload the appropriate document(s) proving your organization's tax-exempt status. (JPG or PDF format))"
                        }
                      </span>
                    )}
                    {this.state.taxErrorMessage && (
                      <span className="errorMassageShow">
                        Only JPG and PDF files are allowed.
                      </span>
                    )}
                  </div> */}
                  <div className="row"
                    style={{
                      margin: "1em 0em 0em 0em",
                      borderTop: "1px solid lightgray",
                    }}
                  >
                    <h6 className="ps-0 mt-3" id="headerLabel">
                      Custom Account Settings
                    </h6>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <label className="form-label" htmlFor="multiStepsEmail">
                        First Name Alternate
                        <InfoTooltip
                          data="Word inserted when first name is not found."
                          style={{
                            float: "right",
                          }}
                        />
                      </label>
                      <input
                        title=""
                        autoComplete="off"
                        type="text"
                        value={this.state.firstNameAlternateValue}
                        onChange={this.handleFirstNameAlternateChange.bind(
                          this
                        )}
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        aria-label="john.doe"
                      />
                    </div>
                  </div >
                  <div className="row mt-2">
                    <div className="col-sm-12">
                      <label className="form-label" htmlFor="multiStepsEmail">
                        Texting Time Window
                      </label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "12px",
                          width: "fit-content",
                        }}
                      >
                        {/* FROM */}
                        <Autocomplete
                          disableClearable
                          autoComplete="off"
                          options={hours}
                          value={this.state.startHour}
                          onChange={(e, val) => this.handleTimeChange("startHour", val)}
                          size="small"
                          sx={{ width: 80 }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="hh" />
                          )}
                        />

                        <Autocomplete
                          disableClearable
                          autoComplete="off"
                          options={minutes}
                          value={this.state.startMinute}
                          onChange={(e, val) => this.handleTimeChange("startMinute", val)}
                          size="small"
                          sx={{ width: 80 }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="mm" />
                          )}
                        />

                        <Autocomplete
                          disableClearable
                          autoComplete="off"
                          options={ampmOptions}
                          value={this.state.startAmpm}
                          onChange={(e, val) => this.handleTimeChange("startAmpm", val)}
                          size="small"
                          sx={{ width: 90 }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="am/pm" />
                          )}
                        />

                        {/* THRU */}
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#444",
                            margin: "0 6px",
                          }}
                        >
                          thru
                        </span>

                        {/* TO */}
                        <Autocomplete
                          disableClearable
                          autoComplete="off"
                          options={hours}
                          value={this.state.endHour}
                          onChange={(e, val) => this.handleTimeChange("endHour", val)}
                          size="small"
                          sx={{ width: 80 }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="hh" />
                          )}
                        />

                        <Autocomplete
                          disableClearable
                          autoComplete="off"
                          options={minutes}
                          value={this.state.endMinute}
                          onChange={(e, val) => this.handleTimeChange("endMinute", val)}
                          size="small"
                          sx={{ width: 80 }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="mm" />
                          )}
                        />

                        <Autocomplete
                          disableClearable
                          autoComplete="off"
                          options={ampmOptions}
                          value={this.state.endAmpm}
                          onChange={(e, val) => this.handleTimeChange("endAmpm", val)}
                          size="small"
                          sx={{ width: 90 }}
                          renderInput={(params) => (
                            <TextField {...params} placeholder="am/pm" />
                          )}
                        />
                      </div>
                    </div >
                  </div >
                </div >
              </div >
            </div >
            <div className="col-md-6" id="companyAddressCol">
              <div className="card " id="giveBeeCardTopBoxShadowremove">
                <div
                  className="card-header d-flex align-items-center justify-content-between p-2"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    Company Address
                  </h6>
                </div>
                <div className="card-body p-2">
                  <AddressWithTimezone
                    action="edit"
                    pageId="orgAddress"
                    ref={this.addressRef}
                    data={this.state.address}
                    timeZone={this.state.timeZone}
                    onChange={this.handleAddressChange.bind(this)}
                  />
                </div>
              </div>
            </div>
            {this.viewTaxDocument()}
          </div >
          {/* <div className="row mt-2">
            <div className="col-md-12">
              <div className="card mt-2" id="giveBeeCard">
                {" "}
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b> Integrated Payment Services</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-6">
                      <label
                        className="form-label "
                        htmlFor="collapsible-firstname"
                      >
                        Select Payment Type
                      </label>
                      <Autocomplete
                        id="size-small-outlined"
                        size="small"
                        autoComplete="off"
                        fullWidth
                        disableClearable
                        ListboxProps={{
                          className: "custom-listbox",
                        }}
                        options={this.state.paymentServiceTypeList}
                        value={this.state.paymentType}
                        getOptionLabel={(option) => option.type}
                        defaultValue={this.state.paymentType}
                        onChange={(event, value) => {
                          this.handlePaymentTypeChange(value);
                        }}
                        inputprops={{
                          style: { textTransform: "capitalize" },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Please Select"
                            variant="outlined"
                            size="small"
                            className="textField"
                            style={{ background: "#fff" }}
                          />
                        )}
                      />
                    </div>
                    {Utils.equalsIgnoreCase(
                      this.state.paymentType?.type,
                      "PayPal"
                    ) && (
                      <div className="col-sm-6">
                        <label className="form-label" htmlFor="multiStepsState">
                          PayPal ID
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="multiStepsName"
                          className="form-control"
                          name="multiStepsName"
                          value={this.state.paypalId}
                          onChange={this.handlePaymentPayPalChange.bind(this)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          < div className="row d-flex align-items-center justify-content-between" >
            <div className="col-sm-12 mt-4 text-center">
              <SaveButton id="saveButton" type="submit">
                {" "}
                Save{" "}
              </SaveButton>
              &nbsp;&nbsp;
              <CancelIconButton onClick={(e) => this.editCancel()} />
            </div>
          </div >
          {/* </div> */}
        </ValidatorForm >
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    organizationTypeList: state.staticData.organizationTypeList,
    businessTypeList: state.staticData.businessTypeList,
    businessIndustryList: state.staticData.businessIndustryList,
    paymentServiceTypeList: state.staticData.paymentServiceTypeList,
  };
};
export default connect(mapStateToProps)(Organization);
